import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('Selector').create(({ theme }) => ({
  root: {
    width: '24px',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    aspectRatio: '1/1',
    border: '1px solid',
    borderColor: theme.colors.borders.secondary,
    backgroundColor: theme.colors.button.secondary.background,
    borderRadius: '100%',
    transition: 'background-color 0.2s ease-in-out, border-width 0.3s ease-in-out',
  },

  childCircle: {
    width: '11px',
    aspectRatio: '1/1',
    borderRadius: '100%',
    backgroundColor: theme.colors.text.primary,
    opacity: '1',
    transition: 'opacity 0.2s ease-in-out',
  },
}))
